import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67e8598a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=67e8598a&prod&rel=stylesheet%2Fless&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=67e8598a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e8598a",
  null
  
)

export default component.exports